<template>
    <div class="breadcrumbs-section">
        <div class="breadcrumbs">
            <span class="navigation" v-on:click="navigateTo('root')">{{l10nHome}}</span>
            <span class="breadcrumb-divider">></span>
            <span class="navigation" v-on:click="navigateTo('storeRoot')">{{l10nStore}}</span>
            <template v-if="isDigitalItemRoute">
                <span class="breadcrumb-divider">></span>
                <span>{{l10nDigitalTalmud}}</span>
            </template>
            <template v-else-if="isCartRoute">
                <span class="breadcrumb-divider">></span>
                <span>{{l10nCart}}</span>
            </template>
            <template v-else>
                <template v-if="isTalmudItemRoute">
                    <span class="breadcrumb-divider">></span>
                    <span class="navigation" v-on:click="navigateTo('storeTalmud')">{{l10nTalmud}}</span>
                    <span class="breadcrumb-divider">></span>
                    <span>{{product.name}}</span>
                </template>
                <template v-else>
                    <span class="breadcrumb-divider">></span>
                    <span>{{l10nTalmud}}</span>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import {
        ROUTE_STORE_SIDDER,
        ROUTE_STORE_TALMUD_ITEM,
        ROUTE_STORE_DIGITAL_ITEM,
        ROUTE_CART,
    } from '../services/constants'
    import helpers from '../services/helpers'

    export default {
        name: 'jabra-breadcrumbs',
        data: function () {
            return {}
        },
        computed: {
            product() {
                let products = null
                switch (this.storeMode) {
                    case ROUTE_STORE_SIDDER:
                        products = this.$store.state.commerceModule.bookProducts.data
                        if (products && products.length > 0) {
                            return products[0]
                        } else {
                            return null
                        }
                    case ROUTE_STORE_TALMUD_ITEM:
                        products = this.$store.state.commerceModule.talmudProducts.data
                        if (products) {
                            const result = products.find(product => {
                                return product.id.toString() === this.$route.params.id
                            })
                            return result ? result : null
                        } else {
                            return null
                        }
                    default:
                        return products
                }
            },
            storeMode() {
                return this.$route.name
            },
            isTalmudItemRoute() {
                return this.storeMode === ROUTE_STORE_TALMUD_ITEM
            },
            isDigitalItemRoute() {
                return this.storeMode === ROUTE_STORE_DIGITAL_ITEM
            },
            isCartRoute() {
                return this.storeMode === ROUTE_CART
            },
            l10nHome() {
                return this.l10nGetter('home')
            },
            l10nStore() {
                return this.l10nGetter('store')
            },
            l10nDigitalTalmud() {
                return this.l10nGetter('digital_talmud')
            },
            l10nCart() {
                return this.l10nGetter('cart')
            },
            l10nTalmud() {
                return this.l10nGetter('talmud')
            },
        },
        methods: {
            navigateTo(routeName) {
                this.$router.push({name: routeName})
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .breadcrumbs-section {
        width: 100%;
        @include font-abraham(16px, $grey-1, 300);
    }

    .breadcrumb-divider {
        margin: 0 5px;
    }

    .navigation {
        cursor: pointer;
    }
</style>
